<script setup lang="ts">
  import { ref } from "vue";
  import serviceImage from "~/assets/images/qrcode/dls-service.jpeg";
  import useToast from "~/composables/useToast";

  const Toast = useToast();
  const serviceImageRef = ref(serviceImage);

  const onCopySuccess = () => {
    Toast("复制成功");
  };
</script>

<template>
  <div class="apply-success">
    <div class="form">
      <div class="form-content">
        <div class="header">
          <icon-font type="xuanzhong" />
          <!-- <Icon name="custom:xuanzhong" />-->
          <span>提交成功</span>
        </div>
        <div class="content">
          <p class="first">感谢您的入驻，审核通过会短信通知您</p>
          <p class="first">如有任何问题，请联系企业微信，谢谢</p>
          <div class="qrcode">
            <img class="qrcode-image" :src="serviceImageRef" />
            <div class="qrcode-text">长按保存二维码</div>
            <div class="qrcode-text">扫描添加企业微信</div>
          </div>
          <div class="web">
            <p>您现在可以在电脑端网页登录</p>
            <p>
              <a>https://dls.delilegal.com</a>
              <span
                v-copy="{
                  text: 'https://dls.delilegal.com',
                  fn: onCopySuccess,
                }"
                class="copy-btn"
                >复制网址</span
              >
            </p>
            <!-- <p>进行使用</p> -->
            <p class="last">或者在手机应用商店搜索得理律助</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .apply-success {
    position: absolute;
    bottom: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 667px;
    height: 91%;

    .form {
      flex-grow: 1;
      padding: 16px;
      padding-bottom: 56px;
      background: #e6ebff;
      border-radius: 32px 32px 0 0;

      .form-content {
        overflow: hidden;
        background: #fff;
        border-radius: 22px;

        .header {
          display: flex;
          align-items: center;
          justify-content: center;
          padding-top: 36px;
          padding-bottom: 16px;
          font-size: 20px;
          font-weight: bold;
          color: #333;

          .anticon {
            margin-right: 16px;
            font-size: 32px;
            color: #28c751;
          }
        }

        .content {
          width: fit-content;
          padding: 0 52px;
          margin: 0 auto;
          color: #333;
          text-align: center;

          .first {
            margin-bottom: 12px;
            font-size: 14px;
          }

          .qrcode {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-top: 24px;
            padding-bottom: 36px;

            .qrcode-image {
              width: 100px;
              height: 100px;
              margin-bottom: 10px;
            }

            .qrcode-text {
              font-size: 14px;
              line-height: 21px;
            }
          }

          .web {
            text-align: left;

            p {
              margin-bottom: 6px;
            }

            .copy-btn {
              display: inline-block;
              height: 20px;
              padding: 0 6px;
              margin-left: 20px;
              font-size: 13px;
              color: #505050;
              cursor: pointer;
              background: #eaeaea;
              border-radius: 60px;
            }

            .last {
              margin-top: 24px;
              margin-bottom: 36px;
            }
          }
        }
      }
    }
  }
</style>
